"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSchoolYearForm = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_box_common_1 = require("../il-box/il-box.common");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_textfield_common_1 = require("../il-textfield/il-textfield.common");
var il_button_common_1 = require("../il-button/il-button.common");
var formik_1 = require("formik");
var new_school_year_validation_1 = require("./new-school-year.validation");
var il_date_picker_common_1 = require("../il-date-picker/il-date-picker.common");
var x_date_pickers_1 = require("@mui/x-date-pickers");
var AdapterDateFns_1 = require("@mui/x-date-pickers/AdapterDateFns");
var date_fns_1 = require("date-fns");
var il_select_common_1 = require("../il-select/il-select.common");
var CreateSchoolYearForm = function (props) {
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            name: '',
            startDate: (0, date_fns_1.startOfDay)(new Date()),
            endDate: (0, date_fns_1.endOfDay)((0, date_fns_1.addWeeks)(new Date(), props.defaultSchoolYearDurationInWeeks)),
            schoolDays: il_select_common_1.WeekDaySelectArgs.defaultSelections,
        },
        validationSchema: new_school_year_validation_1.NewSchoolYearValidation,
        onSubmit: function (values) {
            props.onSubmit(values);
        },
    });
    return (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterDateFns_1.AdapterDateFns },
        react_1.default.createElement(il_box_common_1.ILFormBox, null,
            react_1.default.createElement(material_1.Typography, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    paddingBottom: { sm: '1rem', md: '3rem' },
                }, color: enums_1.ColorPaletteEnum.PRIMARY, variant: enums_1.TypographyVariantEnum.H3 }, props.headingText),
            react_1.default.createElement("form", { onSubmit: formik.handleSubmit },
                react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                    react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Name"),
                    react_1.default.createElement(il_textfield_common_1.SchoolYearTextField, { id: 'name', value: formik.values.name, onChange: formik.handleChange, error: formik.touched.name && Boolean(formik.errors.name), helperText: formik.touched.name && formik.errors.name })),
                react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                    react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Default Dates"),
                    react_1.default.createElement(il_date_picker_common_1.FormattedDatePicker, { label: 'Start Date', onChange: function (newStartDate) {
                            formik.setFieldValue('startDate', (0, date_fns_1.startOfDay)(newStartDate));
                        }, value: formik.values.startDate, renderInput: function (inputProps) { return (react_1.default.createElement(material_1.TextField, __assign({}, inputProps, { id: 'startDate', size: enums_1.SizeEnum.SMALL, error: formik.touched.startDate && Boolean(formik.errors.startDate), helperText: react_1.default.createElement(react_1.default.Fragment, null, formik.touched.startDate && formik.errors.startDate) }))); }, minDate: new Date(), maxDate: formik.values.endDate }),
                    react_1.default.createElement(il_date_picker_common_1.FormattedDatePicker, { label: 'End Date', onChange: function (newEndDate) {
                            formik.setFieldValue('endDate', (0, date_fns_1.endOfDay)(newEndDate));
                        }, value: formik.values.endDate, renderInput: function (inputProps) { return (react_1.default.createElement(material_1.TextField, __assign({}, inputProps, { id: 'endDate', size: enums_1.SizeEnum.SMALL, helperText: react_1.default.createElement(react_1.default.Fragment, null, formik.touched.endDate && formik.errors.endDate) }))); }, minDate: formik.values.startDate })),
                react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                    react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "School Days"),
                    react_1.default.createElement(il_select_common_1.WeekDaySelect, { onChange: function (schoolDays) {
                            formik.setFieldValue('schoolDays', schoolDays);
                        }, sx: { ml: { xs: '-0.75rem', sm: '-0.3rem', md: 'inherit' } }, error: formik.touched.schoolDays && formik.errors.schoolDays, childSx: __assign(__assign({}, il_select_common_1.WeekDaySelectArgs.childSx), { flexGrow: 1 }) })),
                react_1.default.createElement(il_button_common_1.ContainedButton, { sx: __assign(__assign({}, il_button_common_1.ContainedButtonArgs.sx), { width: '100%', mt: '1.5rem' }), type: enums_1.ButtonTypeEnum.SUBMIT }, "Create School Year")))));
};
exports.CreateSchoolYearForm = CreateSchoolYearForm;
